export default __webpack_public_path__ + "static/media/82.d386a892.jpg";